module.exports = __webpack_public_path__ + "static/media/loading-truck-body2.44ff96b4.svg";